<aux-multi-checkbox-select
  #multiCheckboxSelect
  class="multi-vendor-select"
  [options]="options()"
  [loading]="listVendorsQuery.isLoading()"
  [clearable]="false"
  [labelClearable]="false"
  [placeholder]="placeholder"
  [(selectedItems)]="viewVendorIDs"
  [footerRef]="applySelectionOnButton() ? footerRef : null"
  (auxClickOutside)="closeOnSelect()"
  [skipInitial]="false"
  dropdownPosition="bottom"
  [itemsToDisplay]="itemsToDisplay()"
/>

<ng-template #footerRef>
  <div class="flex justify-stretch space-x-4 px-[10px] py-[20px]">
    <aux-button
      class="grow"
      classList="w-full h-[30px]"
      label="Apply"
      [disabled]="isRequired ? !viewVendorIDs().length : false"
      (click)="applyChanges(viewVendorIDs())"
    />
  </div>
</ng-template>
